import React from 'react';
// Jumbotron is removed. We only need Container here.
import { Container } from 'react-bootstrap'; 

// Import all sections. Using './' assumes these files are in the same folder.
import CarouselSection from './CarouselSection';
import ProfileSection from './ProfileSection';
import ServiceArea from './ServiceArea';
import FeedbackSection from './FeedbackSection';
// Note: Footer is imported in App.js, so it's commented out here.
//import Footer from './Footer'; 

const Home = () => {
  return (
    <>
      {/* Replaced Jumbotron with a simple <div> and Bootstrap utility classes */}
      <div className="bg-light text-center py-5">
        <Container>
          <h1>Welcome to Friends-Tech Corporation!</h1>
          <p>Non Stop Textile Solutions And Services in Bangladesh</p>
        </Container>
      </div>

      {/* 1st Section: Image Carousel */}
      <CarouselSection />
      <hr />

      {/* 2nd Section: Profile Picture (Left) and Description (Right) */}
      <ProfileSection />
      <hr />

      {/* 3rd Section: Service Area (Product picture and description) */}
      <ServiceArea />
      <hr />

      {/* 4th Section: Clients Feedback */}
      <FeedbackSection />
      <hr />

      {/* 5th Section: Latest Section */}
      <Container className="my-5">
          <h2>Latest News</h2>
          <p>Check out our latest updates here...</p>
      </Container>
    </>
  );
};

export default Home;